export const singleItemHeight = 80;
export const additionalSpacesHeight = 176;
